import {Box, Button, Center, Flex, Icon, Image, Text} from '@chakra-ui/react'
import LampIcon from '@assets/svgs/learn/lamp-charge.svg'
import ArrowIcon from '@assets/svgs/learn/arrow_right_7.svg'
import CheckIcon from '@assets/svgs/learn/check_2.svg'
import CloseIcon from '@assets/svgs/learn/close_2.svg'
import CloseIcon1 from '@assets/svgs/learn/close.svg'
import {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {FEATURE_REPORT_ERROR, PATH, SCREEN_REPORT_ERROR} from '@utils/Const'
import sentencePracticeRequest from '@apis/sentence-practice'
import './index.css'
import Format1 from './Format1'
import Format2 from './Format2'
import GlobalProgress from '@components/GlobalProgress'
import {audioRef, isParamsValid, pauseAudio} from '@utils'
import DocumentIcon from '@assets/svgs/learn/document_2.svg'
import {Modal} from 'antd'
import {useDispatch, useSelector} from 'react-redux'
import ModalFeedbackRealTime from '@components/ModalFeedbackRealTime'
import {
  updateIsShowModalFeedbackRealTime,
  updateIsShowReportErrorForm,
} from '@redux/shared/shared'
import {ReactComponent as ExclamationCircle} from '@assets/svgs/exclamation-circle.svg'
import FormReportError from '@components/FormReportError'
import GlobalMic3 from '@components/GlobalMic3'

const demoSteps = ['Hoàn thiện câu', 'Nhập vai', 'Tổng kết']

const ReviseSentence = () => {
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const [sentences, setSentences] = useState<any>() // các câu cần ôn
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0) //index câu cần ôn hiện tại
  const [currentForm, setCurrentForm] = useState(1) // dạng ôn câu hiện tại
  const [messages, setMessages] = useState<any>() // list tin nhắn hội thoại
  const [dataInitSession, setDataInitSession] = useState<any>() // data khi khởi tạo phiên hội thoại
  const [historyId, setHistoryId] = useState<any>() // dùng khi khởi tạo session
  const [dataBotResponse, setDataBotResponse] = useState<any>() // câu hỏi hiện tại của bot
  const [isLoadingBot, setIsLoadingBot] = useState<any>(true)
  const [isLoadingUser, setIsLoadingUser] = useState<any>(false)
  const [suggestMessage, setSuggestMessage] = useState<any>() // câu gợi ý để trả lời
  const [usedSuggest, setUsedSuggest] = useState<boolean>(false) // Đã sử dụng gợi ý, check để show feedback
  const [isDisableMic, setIsDisableMic] = useState(true)
  const [isShowBtnContinue, setIsShowBtnContinue] = useState(false)
  const [isShowRestScreen, setIsShowRestScreen] = useState(false) // show màn chờ giữa các câu
  const [dataForm2, setDataForm2] = useState<any>() // Data của dạng 2
  const [textDataForm2, setTextDataForm2] = useState<any>() // text hiển thị dạng 2
  const [isRecoding, setIsRecoding] = useState<any>()
  const [isDisableVolume, setDsDisableVolume] = useState<boolean>(true)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [feedbackKey, setFeedbackKey] = useState<string>('')
  const [screenReportError, setScreenReportError] = useState<string>('')
  const navigate = useNavigate()
  const location = useLocation()
  const {folderId, entry_point} = location.state || {}
  const dispatch: any = useDispatch()

  useEffect(() => {
    if (!isParamsValid([folderId])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!folderId) return
    getSentences(folderId) // Lấy các câu cần ôn trong 1 folder (chỉ gọi 1 lần)
    return () => pauseAudio()
  }, [])

  useEffect(() => {
    if (
      feedbackKey &&
      !dataFeedbackOverview?.feedback_data[feedbackKey]?.is_completed
    ) {
      dispatch(updateIsShowModalFeedbackRealTime(true))
    }
  }, [feedbackKey])

  useEffect(() => {
    if (!sentences) return
    if (currentForm === 1 || (currentForm === 2 && !dataInitSession)) {
      initSession() // Khởi tạo 1 session ôn câu, mỗi 1 câu hỏi trong folder cần tạo 1 sessionId riêng.
    }
  }, [sentences, currentSentenceIndex])

  useEffect(() => {
    if (currentForm === 2 && historyId && dataInitSession) {
      getRolePlayDetails()
    }
  }, [currentForm, historyId, dataInitSession])

  useEffect(() => {
    if (!dataInitSession) return
    const newMsg = {
      type: 'BOT_MSG',
      text_en: dataInitSession?.main_question,
      audio: dataInitSession?.main_question_audio,
    }
    setMessages([newMsg])
    const NewFillMessage = {
      type: 'FILL_MSG',
      text_en: dataInitSession?.sample_answer_with_blank,
    }
    setSuggestMessage(NewFillMessage)
  }, [dataInitSession])

  useEffect(() => {
    // Tự động chuyển câu tiếp theo sau 2s
    if (isShowRestScreen) {
      setTimeout(() => {
        setIsShowRestScreen(false)
        setCurrentSentenceIndex((pre: any) => pre + 1)
      }, 2000)
    }
  }, [isShowRestScreen])

  useEffect(() => {
    // Xử lý phát audio khi bot phản hồi câu trả lời của user dạng 1
    if (
      currentForm === 1 &&
      messages?.length > 0 &&
      messages[messages?.length - 1].type === 'BOT_MSG'
    ) {
      handlePlayAudio(messages[messages?.length - 1].audio, true)
    }
  }, [messages])

  useEffect(() => {
    if (!textDataForm2) return
    if (textDataForm2?.type === 'BOT') {
      setTimeout(() => {
        handlePlayAudio(textDataForm2?.audio)
      }, 500)
    }
    if (textDataForm2?.type === 'USER') {
      // Tự động chuyển câu tiếp theo sau 5s
      setTimeout(() => {
        if (dataBotResponse?.bot_response?.is_pass) {
          setCurrentSentenceIndex((pre: any) => pre + 1)
        }
        const newTextData = {
          type: 'BOT',
          text_en: dataBotResponse?.bot_response?.response_en,
          text_vi: dataBotResponse?.bot_response?.response_vi,
          audio: dataBotResponse?.bot_response?.response_audio,
        }
        setTextDataForm2(newTextData)
      }, 5000)
    }
  }, [textDataForm2])

  useEffect(() => {
    switch (currentForm) {
      case 1:
        setScreenReportError(SCREEN_REPORT_ERROR.HOAN_THIEN_CAU)
        break
      case 2:
        setScreenReportError(SCREEN_REPORT_ERROR.NHAP_VAI)
        break
      default:
        setScreenReportError(SCREEN_REPORT_ERROR.HOAN_THIEN_CAU)
        break
    }
  }, [currentForm])

  const getSentences = async (folderId: any) => {
    try {
      const params = {
        folderId,
      }
      const res = await sentencePracticeRequest.getSentences(params)
      setSentences(res?.data.data.sentences)
      setHistoryId(res?.data.data.history_id)
    } catch (error) {}
  }

  const initSession = async () => {
    setIsLoadingBot(true)
    try {
      const params = {
        user_answer_bucket_id:
          sentences[currentSentenceIndex]?.user_answer_bucket_id,
        sentence_practice_history_id: historyId,
      }
      const res = await sentencePracticeRequest.initSession(params)
      setDataInitSession(res?.data.data)
    } catch (error) {}
    setIsLoadingBot(false)
  }

  const handleClickSuggest = () => {
    setUsedSuggest(true)
    const newSuggestMsg = {
      type: 'SUGGEST_MSG',
      text_en: dataInitSession?.sample_answer,
    }
    setSuggestMessage(newSuggestMsg)
  }

  const handleClickContinue = () => {
    pauseAudio()
    setDsDisableVolume(true)
    setMessages(null)
    setIsShowBtnContinue(false)
    setSuggestMessage(null)
    setDataBotResponse(null)
    if (currentSentenceIndex === sentences.length - 1) {
      if (currentForm === 1) {
        setCurrentForm(2)
        setCurrentSentenceIndex(0)
      }
      if (currentForm === 2) {
        navigate(PATH.LEARN_REVISE_SENTENCE_RESULT, {
          state: {historyId, entry_point},
        })
      }
    } else {
      setIsShowRestScreen(true)
    }
  }

  const handlePlayAudio = (audio: any, isAuto = false) => {
    if (audioRef.current) {
      audioRef.current.pause()
    }
    if (audio) {
      audioRef.current = new Audio(audio)
      audioRef.current.play().catch(function (error: any) {
        setIsDisableMic(false)
        if (isAuto && dataBotResponse?.chat_gpt_response_message.is_finish) {
          setIsShowBtnContinue(true)
        }
      })
      audioRef.current.onended = () => {
        if (currentForm === 1) {
          setDsDisableVolume(false)
          !dataBotResponse?.chat_gpt_response_message.is_finish
            ? setIsDisableMic(false)
            : setIsShowBtnContinue(true)
        }
        if (currentForm === 2) {
          if (
            currentSentenceIndex === sentences.length &&
            dataBotResponse?.bot_response?.is_pass
          ) {
            navigate(PATH.LEARN_REVISE_SENTENCE_RESULT, {
              state: {historyId, entry_point},
            })
          }
          setIsDisableMic(false)
        }
      }
    } else {
      setIsDisableMic(false)
    }
  }

  const getRolePlayDetails = async () => {
    // lấy data chi tiết của dạng 2.
    try {
      const params = {sentence_practice_history_id: historyId}
      const res = await sentencePracticeRequest.getRolePlayDetails(params)
      setDataForm2(res?.data?.data)
      const botMsg = {
        type: 'BOT_MSG',
        text_en: res?.data?.data?.first_question?.first_bot_massage_en,
        text_vi: res?.data?.data?.first_question?.first_bot_massage_vi,
        audio: res?.data?.data?.first_question?.first_bot_massage_audio,
      }
      setMessages([botMsg])
      const newTextData = {
        type: 'BOT',
        text_en: res?.data?.data?.first_message?.response_en,
        text_vi: res?.data?.data?.first_message?.response_vi,
        audio: res?.data?.data?.first_message?.response_audio,
      }
      setTextDataForm2(newTextData)
    } catch (error) {}
  }

  const handleStartRecording = () => {}

  // Xử lý sau khi thu âm xong
  const handleRecordingComplete = async (blob: any) => {
    pauseAudio()
    setDsDisableVolume(true)
    setIsLoadingUser(true)
    setIsDisableMic(true)
    setIsRecoding(true)
    try {
      let file = new File([blob], 'audio.wav', {type: 'audio/wav'})
      const formData = new FormData()
      let params
      if (currentForm === 1) {
        // Xử lý sau khi thu âm xong ở dạng 1
        formData.append('audio-file', file)
        params = {
          formData,
          sessionId: dataInitSession?.practice_session_id,
        }
        const res = await sentencePracticeRequest.sendAudio(params)
        setDataBotResponse(res?.data.data)
        const answerMsg = {
          type: 'USER_MSG',
          text_en: res?.data.data.chat_gpt_response_message.answer_marked,
        }
        const botMsg = {
          type: 'BOT_MSG',
          text_en: res?.data.data.chat_gpt_response_message.response,
          audio: res?.data.data.response_message_audio,
        }
        if (!res?.data.data.chat_gpt_response_message.is_finish) {
          const NewFillMessage = {
            type: 'FILL_MSG',
            text_en: dataInitSession?.sample_answer_with_blank,
          }
          setSuggestMessage(NewFillMessage)
        } else {
          setSuggestMessage(null)
        }
        setMessages((pre: any) => [...pre, answerMsg, botMsg])
        if (usedSuggest) {
          setFeedbackKey('CLICK_SUGGEST_BUTTON')
        }
      }
      if (currentForm === 2) {
        // Xử lý sau khi thu âm xong ở dạng 2
        formData.append('audio-file', file)
        params = {
          formData,
          practiceHistoryId: historyId,
          userAnswerBucketId:
            sentences[currentSentenceIndex]?.user_answer_bucket_id,
        }
        const res = await sentencePracticeRequest.sendAudioRolePlay(params)
        setDataBotResponse(res?.data.data)
        const newTextData = {
          type: 'USER',
          is_pass: res?.data?.data?.bot_response?.is_pass,
          is_correct: res?.data?.data?.is_correct,
          text_en: res?.data?.data?.user_answer_text,
        }
        setTextDataForm2(newTextData)
      }
    } catch (error) {
      setIsDisableMic(false)
      setDsDisableVolume(false)
    }
    setIsLoadingUser(false)
    setIsRecoding(false)
  }

  const handleOpenModal = () => {
    setIsOpenModal(true)
  }

  const handleCancelModal = () => {
    setIsOpenModal(false)
  }

  const handleOke = () => {
    navigate(-1)
  }

  return (
    <Flex h={'100vh'} flexDirection={'column'} gap={'0px'} bg={'#F6F6F6'}>
      <Flex
        className="container-xl"
        w={'100%'}
        h={'120px'}
        alignItems={'center'}>
        <Flex w={{base: '52px', md: '210px'}} flexShrink={0}>
          <Image
            src={CloseIcon1}
            w={{base: '24px', md: '40px'}}
            h={{base: '24px', md: '40px'}}
            cursor={'pointer'}
            onClick={handleOpenModal}
          />
        </Flex>
        <GlobalProgress
          steps={demoSteps}
          currentIndex={currentForm - 1}
          currentPercent={(currentSentenceIndex / sentences?.length) * 100}
          px={{base: '30px', md: '40px'}}
        />
        <Flex
          gap={'8px'}
          alignItems={'center'}
          justifyContent={'end'}
          w={{base: '52px', md: '210px'}}
          flexShrink={0}>
          <Image
            src={DocumentIcon}
            cursor={'pointer'}
            display={{base: 'none', md: 'block'}}
          />
          <Text
            fontSize={{base: '14px', md: '20px'}}
            fontWeight={600}
            color={'#BFBFBF'}>
            {
              <Text as={'span'} color={'#FA8C16'}>
                <Text display={{base: 'none', md: 'inline'}}>Câu</Text>{' '}
                {currentSentenceIndex + 1 <= sentences?.length
                  ? currentSentenceIndex + 1
                  : sentences?.length}
              </Text>
            }{' '}
            / {sentences?.length}
          </Text>
          <Icon
            w={'24px'}
            h="24px"
            ml={'12px'}
            viewBox="0 0 24 24"
            cursor={'pointer'}
            sx={{
              path: {
                fill: '#8c8c8c',
              },
            }}
            onClick={() => {
              dispatch(updateIsShowReportErrorForm(true))
            }}>
            <ExclamationCircle />
          </Icon>
        </Flex>
      </Flex>
      {currentForm === 1 && (
        <Format1
          isShowRestScreen={isShowRestScreen}
          suggestMessage={suggestMessage}
          isLoadingUser={isLoadingUser}
          isLoadingBot={isLoadingBot}
          currentSentenceIndex={currentSentenceIndex}
          messages={messages}
          isDisableVolume={isDisableVolume}
        />
      )}
      {currentForm === 2 && (
        <Format2
          data={dataForm2}
          textData={textDataForm2}
          isRecoding={isRecoding}
        />
      )}
      <Flex h={'150px'} flexShrink={0} justifyContent={'center'} bg={'white'}>
        <Flex gap={{base: '20px', md: '40px'}} alignItems={'center'}>
          {messages?.length <= 1 &&
          currentForm === 1 &&
          suggestMessage.type === 'FILL_MSG' &&
          !isLoadingUser ? (
            <Center
              h={'48px'}
              w={{base: '120px', md: '154px'}}
              gap={'12px'}
              borderRadius={'100px'}
              bg={'#FFF7E6'}
              cursor={'pointer'}
              onClick={handleClickSuggest}>
              <Image src={LampIcon} />
              <Text fontSize={'16'} fontWeight={700} color={'#FA8C16'}>
                Gợi ý
              </Text>
            </Center>
          ) : (
            <Box w={{base: '120px', md: '154px'}} />
          )}
          {(textDataForm2?.type === 'BOT' || currentForm === 1) && (
            <GlobalMic3
              isDisabled={isDisableMic}
              handleStartRecording={handleStartRecording}
              handleRecordingComplete={handleRecordingComplete}
            />
          )}
          {textDataForm2?.type === 'USER' && (
            <Center
              border={`4px solid ${textDataForm2?.is_correct ? 'rgba(93, 208, 45, 0.40)' : 'rgba(255, 77, 79, 0.40)'}`}
              borderRadius={'50%'}>
              <Center
                w={'80px'}
                h={'80px'}
                bg={textDataForm2?.is_correct ? '#5DD02D' : '#FF4D4F'}
                borderRadius={'50%'}>
                <Image
                  src={textDataForm2?.is_correct ? CheckIcon : CloseIcon}
                />
              </Center>
            </Center>
          )}
          <Box w={{base: '120px', md: '154px'}}>
            {isShowBtnContinue && (
              <Center
                h={'48px'}
                w={'100%'}
                gap={'12px'}
                borderRadius={'100px'}
                cursor={'pointer'}
                bg={'#F5F5F5'}
                onClick={handleClickContinue}>
                <Text fontSize={'16px'} fontWeight={700} color={'#263238'}>
                  Tiếp tục
                </Text>
                <Image src={ArrowIcon} />
              </Center>
            )}
          </Box>
        </Flex>
      </Flex>
      <Modal
        title={null}
        open={isOpenModal}
        onCancel={handleCancelModal}
        footer={null}
        width={420}
        styles={{
          content: {
            padding: '32px',
          },
        }}>
        <Flex gap={'16px'} alignItems={'start'}>
          <Icon w={'24px'} h="24px" viewBox="0 0 24 24">
            <path
              d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571 17.5018 2.03571 12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z"
              fill="#FAAD14"
              fillOpacity="0.85"
            />
            <path
              d="M10.7139 16.7143C10.7139 17.0553 10.8493 17.3823 11.0904 17.6234C11.3316 17.8645 11.6586 18 11.9996 18C12.3406 18 12.6676 17.8645 12.9087 17.6234C13.1498 17.3823 13.2853 17.0553 13.2853 16.7143C13.2853 16.3733 13.1498 16.0463 12.9087 15.8052C12.6676 15.564 12.3406 15.4286 11.9996 15.4286C11.6586 15.4286 11.3316 15.564 11.0904 15.8052C10.8493 16.0463 10.7139 16.3733 10.7139 16.7143ZM11.3567 13.7143H12.6424C12.7603 13.7143 12.8567 13.6179 12.8567 13.5V6.21429C12.8567 6.09643 12.7603 6 12.6424 6H11.3567C11.2389 6 11.1424 6.09643 11.1424 6.21429V13.5C11.1424 13.6179 11.2389 13.7143 11.3567 13.7143Z"
              fill="#FAAD14"
              fillOpacity="0.85"
            />
          </Icon>
          <Box>
            <Text fontWeight={600} fontSize={'16px'}>
              Bạn muốn dừng học
            </Text>
            <Text fontSize={'16px'} mt={'8px'}>
              Tiến trình học của bạn sẽ được lưu lại
            </Text>
          </Box>
        </Flex>
        <Flex gap={'16px'} justifyContent={'end'} mt={'24px'}>
          <Button
            borderRadius={'12px'}
            fontWeight={700}
            color={'#434343'}
            onClick={handleOke}>
            Tạm dừng
          </Button>
          <Button
            borderRadius={'12px'}
            bg={'#1890FF'}
            fontWeight={700}
            color={'white'}
            onClick={handleCancelModal}>
            Học tiếp
          </Button>
        </Flex>
      </Modal>
      <ModalFeedbackRealTime feedbackKey={feedbackKey} />
      <FormReportError
        feature={FEATURE_REPORT_ERROR.PRACTICE_SENTENCE}
        screen={screenReportError}
      />
    </Flex>
  )
}

export default ReviseSentence
